/**
 * Microsoft 계정 연동 및 커넥터 등록 서비스
 * 
 * 기존의 클라이언트 사이드 MSAL 인증 방식이 백엔드 일괄 처리로 변경됨에 따라,
 * 이 서비스는 백엔드의 등록 엔드포인트로 리다이렉트하는 역할만 수행합니다.
 */

import { BaseService } from './BaseService';

export class OutlookAuthService extends BaseService {
  /**
   * 커넥터 등록 프로세스 시작 (백엔드로 리다이렉트)
   * 
   * @param connectorType - 등록할 커넥터 타입
   * @param redirectUri - (선택) 완료 후 돌아올 페이지 URI. 기본값은 현재 페이지.
   */
  public registerConnector(connectorType: string, redirectUri: string = window.location.href): void {
    // 1. SSO 토큰 획득
    const ssoToken = this.getAccessToken();
    if (!ssoToken) {
      console.error('SSO token not found. User might not be logged in.');
      throw new Error('로그인 정보가 없습니다. 다시 로그인해주세요.');
    }

    // 2. URL 구성
    // Base URL은 BaseService의 serviceUrl 사용 (환경변수 또는 window.origin)
    // 경로: /connector/register
    // 파라미터: sso_token, connector_type, redirect_uri

    // serviceUrl이 '/'로 끝나는지 확인하여 경로 조합
    const baseUrl = this.serviceUrl.endsWith('/') ? this.serviceUrl.slice(0, -1) : this.serviceUrl;
    const targetPath = '/connector/register';

    const url = new URL(baseUrl + targetPath);
    url.searchParams.append('sso_token', ssoToken);
    url.searchParams.append('connector_type', connectorType);
    url.searchParams.append('redirect_uri', redirectUri);

    console.log(`Redirecting to register connector: ${connectorType}`);
    console.log(`Full URL: ${url.toString()}`);

    // 3. 리다이렉트
    window.location.href = url.toString();
  }

  /**
   * 커넥터 등록 프로세스 (팝업 방식)
   * 
   * @param connectorType - 등록할 커넥터 타입
   * @returns 팝업 윈도우 객체
   */
  public registerConnectorPopup(connectorType: string): Window | null {
    const ssoToken = this.getAccessToken();
    if (!ssoToken) {
      console.error('SSO token not found.');
      throw new Error('로그인 정보가 없습니다.');
    }

    const baseUrl = this.serviceUrl.endsWith('/') ? this.serviceUrl.slice(0, -1) : this.serviceUrl;
    const targetPath = '/connector/register';

    // 팝업 콜백 URL 설정
    const redirectUri = `${window.location.origin}/auth/callback`;

    const url = new URL(baseUrl + targetPath);
    url.searchParams.append('sso_token', ssoToken);
    url.searchParams.append('connector_type', connectorType);
    url.searchParams.append('redirect_uri', redirectUri);

    const width = 600;
    const height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    return window.open(
      url.toString(),
      'ConnectMicrosoft',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  }
}

// 싱글톤 인스턴스
export const outlookAuthService = new OutlookAuthService();
